import Reveal from "./Reveal";

const IMAGES = [
  {
    src: "https://images.unsplash.com/photo-1687579520868-b22b33ca8fa5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBzcGElMjBpbnRlcmlvciUyMHdhcm0lMjBuZXV0cmFsc3xlbnwwfHx8fDE3NzgyODc2MTB8MA&ixlib=rb-4.1.0&q=85",
    label: "The studio",
    span: "md:col-span-6 md:row-span-2",
    h: "h-[520px]",
  },
  {
    src: "https://images.unsplash.com/photo-1722185388507-0a46e2d9dcca?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBzcGElMjBpbnRlcmlvciUyMHdhcm0lMjBuZXV0cmFsc3xlbnwwfHx8fDE3NzgyODc2MTB8MA&ixlib=rb-4.1.0&q=85",
    label: "Set the table",
    span: "md:col-span-3",
    h: "h-[250px]",
  },
  {
    src: "https://images.unsplash.com/photo-1722350553295-ba84043b64cc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwzfHxtYXNzYWdlJTIwZmFjaWFsJTIwYWVzdGhldGljaWFuJTIwdHJlYXRtZW50fGVufDB8fHx8MTc3ODI4NzYxMHww&ixlib=rb-4.1.0&q=85",
    label: "Treat the skin",
    span: "md:col-span-3",
    h: "h-[250px]",
  },
  {
    src: "https://images.unsplash.com/photo-1700522924565-9fad1c05469e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwxfHxtYXNzYWdlJTIwdGhlcmFwaXN0JTIwbmV1dHJhbHxlbnwwfHx8fDE3NzgyODc2MjJ8MA&ixlib=rb-4.1.0&q=85",
    label: "Release the body",
    span: "md:col-span-3",
    h: "h-[250px]",
  },
  {
    src: "https://images.unsplash.com/photo-1600200537812-6ef744442f00?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHw0fHxuYXR1cmFsJTIwZ2xvd2luZyUyMHNraW4lMjB3b21hbiUyMG1ha2V1cHxlbnwwfHx8fDE3NzgyODc2MTB8MA&ixlib=rb-4.1.0&q=85",
    label: "Soft glam",
    span: "md:col-span-3",
    h: "h-[250px]",
  },
];

export default function Gallery() {
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="relative py-24 md:py-36 bg-[#FAF6E8]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-8 mb-12 md:mb-20 items-end">
          <div className="col-span-12 md:col-span-7">
            <Reveal className="overline mb-6">Before &amp; after &middot; the studio</Reveal>
            <Reveal delay={1}>
              <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05] font-light bb-ink">
                Quiet rooms. <br />
                <span className="italic text-[#C9A65A]">Confident</span> results.
              </h2>
            </Reveal>
          </div>
          <Reveal delay={2} className="col-span-12 md:col-span-5">
            <p className="bb-ink-soft max-w-md text-base sm:text-lg leading-relaxed font-light">
              A look around the studio and the small, real moments after a
              treatment — softened skin, lifted shoulders, a slow exhale.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 md:auto-rows-[250px] gap-4 md:gap-5">
          {IMAGES.map((img, i) => (
            <Reveal
              key={i}
              delay={i + 1}
              testId={`gallery-tile-${i + 1}`}
              className={`relative overflow-hidden rounded-lg group ${img.span} ${img.h}`}
            >
              <img
                src={img.src}
                alt={`${img.label} — Beauty & Balance by Bella, downtown Sacramento`}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.04]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0F1F4E]/40 via-transparent to-transparent" />
              <div className="absolute bottom-4 left-4 right-4 flex items-center justify-between">
                <span className="overline text-[#FAF6E8]">{img.label}</span>
                <span className="font-serif italic text-[#FAF6E8] text-lg">
                  0{i + 1}
                </span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
